
import React from 'react';
import { Button } from '@/components/ui/button';
import { useAuth } from '../contexts/AuthContext';
import { triggerNotification } from '../services/triggerNotification';
import { useToast } from '@/hooks/use-toast';
import { useTranslation } from 'react-i18next';

const TestNotificationButton = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { toast } = useToast();
  const [sending, setSending] = React.useState(false);

  const sendTestNotification = async () => {
    if (!user) return;
    
    setSending(true);
    try {
      const result = await triggerNotification({
        recipient_user_id: user.id,
        content: "This is a test notification. If you see this, push notifications are working!",
        type: 'system',
        send_push: true
      });

      if (result.success) {
        toast({
          title: t('pushNotifications.testSent'),
          description: t('pushNotifications.testSentDesc'),
        });
      } else {
        toast({
          title: t('pushNotifications.testFailed'),
          description: "There was an error sending the test notification.",
          variant: "destructive",
        });
      }
    } catch (error) {
      console.error('Error sending test notification:', error);
      toast({
        title: t('common.error'),
        description: "There was a problem sending the test notification.",
        variant: "destructive",
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <Button 
      onClick={sendTestNotification}
      disabled={sending || !user}
      variant="outline"
    >
      {sending ? t('pushNotifications.sending') : t('pushNotifications.sendTest')}
    </Button>
  );
};

export default TestNotificationButton;
